import React from 'react';
import './LayoutEmpty.less';
import { FormattedMessage } from 'react-intl';

function LayoutEmpty({ children, menu }) {
  let year = new Date().getFullYear();
  return (
    <div className="layout-empty">
      <div className="app-header-container">
        <div className="app-header-wrapper">
          <div className="abb-bar">
            <FormattedMessage id="layout.appname" />
          </div>
        </div>
      </div>
      <div className="app-body-container">
        <div className="app-body-wrapper">{children}</div>
      </div>
      <div className="app-footer-container">
        <div className="app-footer-wrapper">&copy; {year} ABB</div>
      </div>
    </div>
  );
}

export default LayoutEmpty;
